<template>
  <v-content>
    <div id="recaptcha-container" />
    <v-container justify-center class="settings__container">
      <v-layout class="mb-2" align-center>
        <h1>Reports</h1>
        <v-spacer />
      </v-layout>
      <v-card flat class="content-container">
        <v-layout column>
          <v-alert
            :value="true"
            outline
            block
            :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
            color="primary"
            class="text-xs-left mx-3 mt-3"
          >
            Start by dragging and dropping an excelsheet below.
          </v-alert>
          <v-container @drop.prevent="addFile" @dragover.prevent>
            <v-layout column>
              <v-layout
                class="mt-2 mb-3 drag-and-drop"
                column
                align-center
                justify-center
              >
                <div><v-icon>cloud_upload</v-icon></div>
                <div>
                  <span @click="openImportDocumentsDialog()"
                    >Drop files here or
                    <span class="clickable primary--text"
                      >click to select</span
                    ></span
                  >
                </div>
              </v-layout>
            </v-layout>
          </v-container>
          <!--
          <v-dialog
            width="600"
            v-model="importDocumentsDialogOpened"
            :fullscreen="$vuetify.breakpoint.xsOnly"
            @keydown.esc="importDocumentsDialogOpened = false"
          >
            <v-card flat @drop.prevent="addFile" @dragover.prevent>
              <v-card-title class="dialog-title pb-0">
                {{$t('documents.uploadDocuments')}}
              </v-card-title>
              <v-card-text>
                <v-alert :value="true" outline block :icon="$vuetify.breakpoint.smAndUp ? 'info' : '' " color="primary" class="text-xs-left mb-4 mx-2">
                  {{$t('alerts.dragAndDropFiles')}}
                </v-alert>
                <v-layout column>
                  <v-flex class="text-xs-left mb-2 font-weight-bold">
                    <v-layout align-center>
                      <div class="py-3">{{$t('documents.selectedDocuments')}}:</div>
                      <v-spacer />
                      <v-progress-circular v-if="documentImporting" indeterminate size="25" class="primary--text mr-2" />
                      <v-btn outline class="default-input text-capitalize primary--text" :disabled="documentImporting" @click="pickDocuments">
                        <v-layout align-center>
                          <v-icon class="mr-2" size="20">add</v-icon>
                          {{$t('documents.selectFiles')}}
                        </v-layout>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                  <v-flex class="text-xs-left mb-4" v-if="isEmpty(documentsToImport)">
                    No documents selected.
                  </v-flex>
                  <v-flex class="mb-4" v-else>
                    <v-layout align-center :key="i" v-for="(doc,i) in documentsToImport">
                      <v-icon color="primary">
                        insert_drive_file
                      </v-icon>
                      <span class="ml-1 my-1">{{doc.name}}</span>
                      <v-spacer />
                      <v-icon @click="documentsToImport.splice(i, 1)" style="cursor:pointer" color="error">cancel</v-icon>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  class="text-capitalize primary"
                  @click="importDocuments()"
                  :disabled="documentImporting || isEmpty(documentsToImport)"
                >
                  {{$t('documents.uploadAll')}}
                </v-btn>
                <v-btn
                  class="text-capitalize primary--text"
                  outline
                  @click="importDocumentsDialogOpened = false;documentsToImport = []"
                >
                  {{ $t('cancel') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
        </v-layout>
        <!-- <v-card-text>
          <v-layout class="title mb-4 px-2">
            Variable
          </v-layout>
          <v-layout class="text-xs-left" wrap>
            <v-flex xs12 sm2 class="px-2">
              <div>Row # <span class="error--text">*</span></div>
              <v-text-field
                name="first-name"
                placeholder="Jack"
                type="text"
                :value="13"
                required
                :rules="fieldRules"
                solo
                class="default-input"
                id="first-name"
              />
            </v-flex>
            <v-flex xs12 sm2 class="px-2">
              <div>Column # <span class="error--text">*</span></div>
              <v-text-field
                name="first-name"
                placeholder="Jack"
                type="text"
                :value="18"
                required
                :rules="fieldRules"
                solo
                class="default-input"
                id="first-name"
              />
            </v-flex>
            <v-flex xs12 sm3 class="px-2 text-xs-left">
              <div>
                Source
              </div>
              <v-select
                :value="'Drake'"
                solo
                hide-details
                :items="[
                  'Drake',
                  'Documents',
                  'Override',
                ]"
                class="default-input"
              />
            </v-flex>
            <v-flex xs12 sm5 class="px-2">
              <div>Value<span class="error--text">*</span></div>
              <v-text-field
                placeholder="Smith"
                type="text"
                :value="'current_tax_payer_agi'"
                required
                solo
                class="default-input"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-btn id="save-changes-button" block class="primary--text text-capitalize" @click="save" :disabled="!userSavable" flat>
              <v-icon>
                add
              </v-icon>
            </v-btn>
          </v-layout>
        </v-card-text> -->
        <v-card-actions>
          <v-layout align-center class="text-xs-center">
            <v-spacer class="hidden-xs-only" />
            <v-btn
              id="save-changes-button"
              class="primary text-capitalize ml-2"
              @click="save"
              :disabled="!userSavable"
            >
              Generate
            </v-btn>
            <v-btn
              id="save-changes-button"
              class="primary--text text-capitalize ml-2"
              @click="save"
              :disabled="!userSavable"
              outline
            >
              Schedule
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import { ref, reactive, computed, onMounted } from '@vue/composition-api';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import firebase from 'firebase/app';
import 'firebase/auth';
import API from '@/api';
import { states, timeZones } from '@/constants/variables';

export default {
  setup(_, { root }) {
    let importDocumentsDialogOpened = ref(true);
    let documentImporting = ref(false);
    let documentsToImport = ref([]);
    let recaptchaVerifier = ref(null);
    let myAvailabilityDialogOpened = ref(false);
    let selectedDayName = ref('Monday');
    let savedAvailability = ref([]);
    let currentCompany = ref({
      user: {},
    });
    let createCustomReportDialogOpened = ref(false);
    const fieldRules = ref([v => !!v || 'This field is required']);
    let firmUsers = ref([]);
    const phoneRules = ref([
      v => !!v || 'Required for Two-factor authentication',
    ]);

    const notificationMethods = ref([
      {
        name: 'Email Immediately',
        value: 'email',
      },
      {
        name: 'Daily Summary',
        value: 'daily_batch',
      },
      {
        name: 'No Email',
        value: 'none',
      },
    ]);
    const userSavable = computed(() => {
      return currentUser.fname && currentUser.lname;
    });

    const store = computed(() => root.$store).value;
    const currentUser = store.getters.user;
    const isAdvisor = store.getters.isAdvisor;

    async function save() {
      store.commit('application/START_LOADING');
      const {
        id,
        fname,
        lname,
        phone_number,
        time_zone,
        out_of_office_setting,
        enabled_2fa,
        notification_setting,
      } = currentUser;

      const {
        enabled,
        redirect_user_id,
        default_message,
      } = out_of_office_setting;

      const {
        questionnaire_related,
        document_related,
        conversation_related,
      } = notification_setting;

      try {
        await API.advisor.updateAdvisor({
          id,
          fname,
          lname,
          phone_number,
          time_zone,
          enabled,
          redirect_user_id,
          default_message,
          enabled_2fa,
          questionnaire_related,
          document_related,
          conversation_related,
        });
        await store.dispatch('getCurrentUser');
        store.dispatch('application/setSuccessNotification', {
          message: 'The information is updated successfully.',
        });
      } catch (e) {
        store.dispatch('application/setErrorNotification', {
          message: 'Something went wrong while saving information.',
          errorToSend: e,
          userEmail: currentUser.email,
        });
      } finally {
        store.commit('application/END_LOADING');
      }
    }

    async function pickDocuments() {
      // const input = this.$refs.selectedDocuments;
      // input.type = 'text';
      // input.type = 'file';
      // this.$refs.selectedDocuments.click();
    }
    // Mounted
    onMounted(async () => {
      console.log(`the component is now mounted.`);
      recaptchaVerifier.value = new firebase.auth.RecaptchaVerifier(
        'recaptcha-container',
        {
          size: 'invisible',
        },
      );

      try {
        const response2 = await API.company.getCompany(
          currentUser.default_company_id,
        );
        currentCompany.value = response2.data;
        const response = await API.firm.getAllUsers();

        if (response.data.error) {
          console.log(response.data.error);
        } else {
          firmUsers = [
            {
              id: null,
              name: 'None',
            },
            ...response.data.users.filter(u => u.id !== currentUser.id),
          ];
        }
      } catch (e) {
        console.log(e);
      } finally {
        store.commit('application/END_LOADING');
      }
    });

    return {
      importDocumentsDialogOpened,
      documentImporting,
      documentsToImport,
      states,
      timeZones,
      recaptchaVerifier,
      notificationMethods,
      currentCompany,
      fieldRules,
      firmUsers,
      phoneRules,
      currentUser,
      isAdvisor,
      resetPassword,
      userSavable,
      save,
      isEmpty,
    };
  },
};
</script>

<style lang="postcss" scoped>
.container {
  max-width: 1000px;
}
.settings__container {
  max-width: 700px;
}
.google-sign-in {
  cursor: pointer;
}
.documents-title {
  font-size: 34px;
}

.dialog-title {
  font-size: 22px;
  font-weight: 700;
}

.drag-and-drop {
  height: 140px;
  border-radius: 4px;
  background: #eee;
  border: 1px solid rgba(0, 0, 0, 0.15);

  & >>> i {
    color: rgba(0, 0, 0, 0.3);
  }

  & >>> span {
    color: rgba(0, 0, 0, 0.6);
  }

  & >>> span.clickable {
    cursor: pointer;
  }
}

.search-input {
  font-size: 14px;

  & >>> .v-input__slot {
    border: 1px solid #bdbdbd !important;
  }
}

.breadcrumbs {
  & >>> .clickable {
    cursor: pointer;
    color: #777;
  }
  & >>> .clickable:hover {
    color: #000;
  }
}

.documents-table {
  & >>> table.v-table thead th {
    font-weight: 700;
    font-size: 14px;
    color: #666;
  }
  & >>> table.v-table tbody td {
    font-size: 14px;
  }
  & >>> table.v-table .v-input__slot .theme--light {
    color: #ccc;
  }
  & >>> .file-icon {
    color: #545454;
  }
}

.new-folder-btn {
  text-transform: none;
  font-weight: 700;
  padding: 12px;
}

.action-btn {
  text-transform: none;
  font-weight: 700;
  padding: 12px;
}

.new-folder-btn i,
.action-btn i {
  margin-right: 4px;
}

.v-list {
  & >>> .v-list__tile {
    font-size: 14px;
  }
}

.documents {
  &__icon {
    font-size: 24px;
  }
}

.document-action {
  &__icon {
    font-size: 20px;
  }
}

.documents-row {
  &__updated-date {
    color: #333;
  }
}

.image-holder {
  display: block;
  width: 200px;
  height: 200px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
</style>
